<script>
  import { toast } from "./stores.js";
  let password_wrong = false;

  async function fetch_login(username, password) {
    const response = await fetch(`${location.origin}/login/`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: username, password: password }),
    });

    return response;
  }

  async function login() {
    const username = document.querySelector("#username").value;
    const password = document.querySelector("#password").value;
    const response = await fetch_login(username, password);
    if (response.status == 403) {
      toast.push("Falsche Anmeldedaten.", {
        theme: { "--toastBackground": "#F56565" },
        initial: 0,
        next: 1,
      });
      password_wrong = true;
      return;
    }

    if (response.status == 404) {
      toast.push("Konnte nicht Aufgelöst werden.", {
        theme: { "--toastBackground": "#F56565" },
        initial: 0,
        next: 1,
      });
      return;
    }

    if (response.status == 401) {
      toast.push("Nicht berechtigt.", {
        theme: { "--toastBackground": "#F56565" },
        initial: 0,
        next: 1,
      });
      return;
    }

    window.location.replace(`${location.origin}/dashboard/`);
  }
</script>

<div
  class="min-h-full flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-gray-100"
>
  <div
    class="max-w-md w-full space-y-8 bg-white p-4 rounded-lg shadow-xl"
    id="login"
  >
    <div>
      <img
        class="mx-auto h-24 w-auto"
        src="https://troiber.servicebund.de/_Resources/Persistent/2fd3428fcb8e6355dd51eb754642587b329f3d2f/sb_troiber_master_rgb_2015-200x81.png"
        alt="Workflow"
      />
      <p class="mt-2 text-center text-sm text-gray-600" />
    </div>
    <form class="mt-8 space-y-6" action="#" method="POST">
      {#if password_wrong}
        <div class="rounded-md shadow-sm -space-y-px">
          <p class="text-center text-red-500">Anmeldedaten sind falsch.</p>
          <div>
            <label for="username" class="sr-only">Username</label>
            <input
              id="username"
              name="username"
              type="username"
              autocomplete="false"
              required
              class="appearance-none text-center  rounded-t-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm"
              placeholder="Email"
            />
          </div>
          <div>
            <label for="password" class="sr-only">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              autocomplete="false"
              required
              class="appearance-none text-center rounded-b-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm"
              placeholder="password"
            />
          </div>
        </div>
      {:else}
        <div class="rounded-md shadow-sm -space-y-px">
          <div>
            <label for="username" class="sr-only">Username</label>
            <input
              id="username"
              name="username"
              type="username"
              autocomplete="false"
              required
              class="appearance-none text-center  rounded-t-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm"
              placeholder="Email"
            />
          </div>
          <div>
            <label for="password" class="sr-only">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              autocomplete="false"
              required
              class="appearance-none text-center rounded-b-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm"
              placeholder="Passwort"
            />
          </div>
        </div>
      {/if}

      <div>
        <button
          on:click|preventDefault={login}
          type="submit"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-400"
        >
          <span class="absolute left-0 inset-y-0 flex items-center pl-3">
            <svg
              class="h-5 w-5 text-gray-200 group-hover:text-gray-100"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          Login
        </button>
      </div>
    </form>
  </div>
</div>
